import { useQuery } from "@tanstack/react-query";
import { Card, Form, message, Row, Col, Select, Typography } from "antd";
import { useForm } from "antd/es/form/Form";
import { useParams } from "react-router";
import { useEffect } from "react";
import CardFooterAction from "../../../components/CardFooterAction";
import { useGetDetailApi, useStoreUpdateApi } from "../../../hooks/useApi";
import { iscoService } from "../../../services/isco.service";
import { sectorService } from "../../../services/sector.service";
import CustomTextInput from "../../../components/CustomTextInput";

export default function ISCOForm() {
  const { id } = useParams();
  const [form] = useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const { data: sectorals } = useQuery({
    queryKey: ["sectorals"],
    queryFn: () => sectorService.fetchAllWithoutPaginate(),
  });

  const { data } = useGetDetailApi({
    id,
    serviceFn: iscoService.findById,
    queryKey: ["isco"],
  });

  const { storeMutation, updateMutation } = useStoreUpdateApi({
    service: iscoService,
    form: form,
    messageApi: messageApi,
    queryKey: "isco",
    route: "/master-data/isco",
  });

  useEffect(() => {
    if (id && data) {
      form.setFieldsValue(data);
    }
  }, [form, id, data, sectorals]);

  const isPending = storeMutation.isLoading || updateMutation.isLoading;

  const handleSubmit = (values) => {
    if (!id) {
      storeMutation.mutate(values);
    } else {
      updateMutation.mutate({ id, data: values });
    }
  };

  return (
    <>
      {contextHolder}
      <Card
        title={(id ? "Ubah" : "Tambah") + " ISCO"}
        actions={[
          <CardFooterAction
            key={"submit"}
            route={"/master-data/isco"}
            onClick={() => form.submit()}
            loading={isPending}
            primaryText="Simpan"
            secondaryText="Batal"
          />,
        ]}
      >
        <Form layout="vertical" form={form} onFinish={handleSubmit}>
          <Row gutter={[20]}>
            <Col span={24}>
              <Form.Item
                name="SectoralId"
                label={
                  <Typography.Text>
                    Sektoral
                    <Typography.Text style={{ color: "#940808" }}>
                      *
                    </Typography.Text>
                  </Typography.Text>
                }
                required={false}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  size="large"
                  options={sectorals?.data.map((e) => ({
                    label: e.name,
                    value: e.uuid,
                  }))}
                  showSearch
                  optionFilterProp="label"
                />
              </Form.Item>
            </Col>
            <Col span={12}>
              <CustomTextInput
                label="Kode ISCO"
                name="code"
                rules={[{ required: true, message: "Kode ISCO harus diisi" }]}
                disabled={isPending}
              />
            </Col>
            <Col span={12}>
              <CustomTextInput
                label="Jabatan ISCO"
                name="position"
                rules={[
                  { required: true, message: "Jabatan ISCO harus diisi" },
                ]}
                disabled={isPending}
              />
            </Col>
            <Col span={24}>
              <CustomTextInput
                label="Jabatan KBJI"
                name="kbjiPosition"
                rules={[
                  { required: true, message: "Jabatan KBJI harus diisi" },
                ]}
                disabled={isPending}
              />
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
}
